import {
	Modal,
} from 'react-bootstrap';
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';
import {
	Colors,
	ColorBackgroundHEX,
} from 'utils/color/ColorPalette'
import {
	MdOutlineArrowBackIos,
	MdOutlineClose,
} from 'react-icons/md';
import './modalstack.scss';
import Button, {
	ButtonColor,
} from 'components/button';

interface ModalDamagedGoodsProps {
	header: string,
	showHide: boolean,
	setShowHide: (showHide: boolean) => any,
	setHideAll: (showHide: boolean) => any,
	children: JSX.Element,
}

const ModalStack = ({
	header, showHide, setShowHide, setHideAll, children,
}: ModalDamagedGoodsProps) => {

	const closeAll = () => {
		setHideAll(true);
		setShowHide(false);
	}

	return(
		<Modal
			id="modal-stack"
			dialogClassName="deviation-registration-modal"
			show={showHide}
			onHide={() => setShowHide(false)}
			animation
		>
			<Modal.Header>
				<Button
					color={ButtonColor.COMPACT}
					onClick={() => setShowHide(!showHide)}
				>
					<MdOutlineArrowBackIos size={'21px'} color={Colors.neutrals.tints.gy400.hex}/>
				</Button>
				<Modal.Title
					style={{
						width: '100%',
					}}
				>
					<Typography center type={TypographyType.buttonLarge}>{header}</Typography>
				</Modal.Title>
				<MdOutlineClose size={'21px'} color={Colors.neutrals.tints.gy400.hex} onClick={() => closeAll()} />
			</Modal.Header>
			<Modal.Body
				style={{
					backgroundColor: ColorBackgroundHEX.gray.primary,
				}}
			>
				{children}
			</Modal.Body>
		</Modal>
	)
}

export default ModalStack;